query userWithNotificationSettings {
  userWithNotificationSettings {
    id
    phone
    notificationSettings {
      leadAssigned {
        sms
        email
      }
      newConversion {
        sms
        email
      }
      news {
        email
        whatsapp
      }
      reminder {
        email
      }
      dueDate {
        email
        sms
      }
      contentDepletion {
        email
      }
      socialMediaPostReminder {
        email
      }
    }
  }
}
